export default "__VITE_ASSET__BiDGZDT8__"